import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Lock, CheckCircle, ArrowRight } from 'lucide-react';
// You can use a CSS module or inline styles. I'll use inline for instant compatibility.

const UpgradeModal = ({ title, message, onClose }) => {
    const navigate = useNavigate();

    const handleUpgradeClick = () => {
        // 1. Close the modal
        if (onClose) onClose();
        // 2. Navigate to pricing anchor
        navigate('/subscription/subscribenew');
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                
                {/* Header with Gold Gradient */}
                <div style={styles.header}>
                    <div style={styles.iconWrapper}>
                        <Lock size={24} color="#713f12" />
                    </div>
                    <button style={styles.closeBtn} onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <div style={styles.content}>
                    <h2 style={styles.title}>{title || "Unlock Premium Features"}</h2>
                    <p style={styles.message}>
                        {message || "This feature is available exclusively to Pro members. Upgrade now to unlock full access."}
                    </p>

                    {/* Benefit List (Optional visual reinforcement) */}
                    <div style={styles.benefits}>
                        <div style={styles.benefitItem}><CheckCircle size={16} color="#059669" /> <span>Unlimited Job Leads</span></div>
                        <div style={styles.benefitItem}><CheckCircle size={16} color="#059669" /> <span>Priority Listings</span></div>
                        <div style={styles.benefitItem}><CheckCircle size={16} color="#059669" /> <span>AI Project Management</span></div>
                        <div style={styles.benefitItem}><CheckCircle size={16} color="#059669" /> <span>AI Job Assistant</span></div>
                        <div style={styles.benefitItem}><CheckCircle size={16} color="#059669" /> <span>Post sub-contractor jobs</span></div>
                        <div style={styles.benefitItem}><CheckCircle size={16} color="#059669" /> <span>View Contact Details</span></div>

                    </div>

                    <button style={styles.ctaButton} onClick={handleUpgradeClick}>
                        Upgrade to Unlock <ArrowRight size={18} />
                    </button>
                    
                    <button style={styles.linkButton} onClick={onClose}>
                        No thanks, maybe later
                    </button>
                </div>
            </div>
        </div>
    );
};

// Simple inline styles to ensure it works immediately without setting up CSS modules
const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: 'fadeIn 0.2s ease-out'
    },
    modal: {
        backgroundColor: 'white',
        borderRadius: '16px',
        width: '90%', maxWidth: '450px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        overflow: 'hidden',
        position: 'relative'
    },
    header: {
        background: 'linear-gradient(135deg, #fef9c3 0%, #fde047 100%)', // Gold gradient
        height: '100px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        position: 'relative'
    },
    iconWrapper: {
        background: 'white',
        padding: '16px',
        borderRadius: '50%',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    closeBtn: {
        position: 'absolute', top: '15px', right: '15px',
        background: 'rgba(255,255,255,0.5)',
        border: 'none', borderRadius: '50%',
        width: '32px', height: '32px',
        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    content: {
        padding: '30px',
        textAlign: 'center'
    },
    title: {
        fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937',
        margin: '0 0 10px 0'
    },
    message: {
        color: '#6b7280', fontSize: '0.95rem', lineHeight: '1.5',
        marginBottom: '20px'
    },
    benefits: {
        background: '#f9fafb',
        padding: '15px',
        borderRadius: '8px',
        marginBottom: '25px',
        textAlign: 'left'
    },
    benefitItem: {
        display: 'flex', alignItems: 'center', gap: '10px',
        marginBottom: '8px', fontSize: '0.9rem', color: '#374151'
    },
    ctaButton: {
        width: '100%',
        backgroundColor: '#2563eb', // Brand Blue
        color: 'white',
        padding: '12px',
        border: 'none', borderRadius: '8px',
        fontSize: '1rem', fontWeight: '600',
        cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
        transition: 'background 0.2s'
    },
    linkButton: {
        background: 'none', border: 'none',
        color: '#9ca3af',
        marginTop: '15px',
        cursor: 'pointer',
        fontSize: '0.85rem'
    }
};

export default UpgradeModal;